import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { format } from "date-fns";

const ClientProjectItem = ({ project, onClick }) => {
  const theme = useTheme();

  const handleClick = () => {
    if (onClick) onClick(project);
  };

  return (
    <Box
      sx={{
        borderRadius: "8px",
        padding: "4px",
        boxShadow: theme.shadows[4],
        cursor: onClick ? "pointer" : "default",
        "&:hover": { bgcolor: theme.palette.primary.light },
      }}
      onClick={handleClick}
    >
      <Typography sx={{ fontWeight: "bold", fontSize: "12px" }}>
        {project.client.name}
      </Typography>
      <Typography sx={{ fontSize: "10px" }}>{project.name}</Typography>
      <Typography sx={{ fontSize: "8px" }}>
        {`${
          project.startsOn
            ? format(project.startsOn, "EEE, MMM dd")
            : "no start"
        } to ${
          project.endsOn ? format(project.endsOn, "EEE, MMM dd") : "no finish"
        }`}
      </Typography>
    </Box>
  );
};

export default ClientProjectItem;
